/**
 * Sub-menu Toggle Functionality
 *
 * Handles toggle functionality for sub-menus in both desktop and mobile menus.
 * Sub-menus are hidden by default and shown when the toggle arrow is clicked.
 */

( function() {
	'use strict';

	// Wait for DOM to be ready
	function initSubMenus() {
		// Find all sub-menu toggles (both in header and mobile menu)
		const subMenuToggles = document.querySelectorAll( '.submenu-toggle' );

		if ( ! subMenuToggles.length ) {
			return;
		}

		// Handle toggle click
		subMenuToggles.forEach( function( toggle ) {
			toggle.addEventListener( 'click', function( event ) {
				event.preventDefault();
				event.stopPropagation();

				const menuItem = toggle.closest( 'li.has-submenu' );
				if ( ! menuItem ) {
					return;
				}

				const subMenu = menuItem.querySelector( '.sub-menu' );
				if ( ! subMenu ) {
					return;
				}

				const isExpanded = toggle.getAttribute( 'aria-expanded' ) === 'true';

				// Toggle aria-expanded
				toggle.setAttribute( 'aria-expanded', isExpanded ? 'false' : 'true' );

				// Toggle active class on menu item (CSS handles visibility)
				menuItem.classList.toggle( 'submenu-open', ! isExpanded );
			} );

			// Handle keyboard (Enter/Space) on toggle button
			toggle.addEventListener( 'keydown', function( event ) {
				if ( event.key === 'Enter' || event.key === ' ' ) {
					event.preventDefault();
					toggle.click();
				}
			} );
		} );

		// Close sub-menus when clicking outside (for desktop menu)
		document.addEventListener( 'click', function( event ) {
			// Only handle desktop menu (not mobile menu)
			const headerNav = document.getElementById( 'site-navigation' );
			if ( ! headerNav || ! headerNav.contains( event.target ) ) {
				// Close all open sub-menus in header
				const headerSubMenus = headerNav ? headerNav.querySelectorAll( 'li.has-submenu.submenu-open' ) : [];
				headerSubMenus.forEach( function( menuItem ) {
					const toggle = menuItem.querySelector( '.submenu-toggle' );
					if ( toggle ) {
						toggle.setAttribute( 'aria-expanded', 'false' );
						menuItem.classList.remove( 'submenu-open' );
					}
				} );
			}
		} );

		// Handle keyboard navigation (ESC to close sub-menu)
		document.addEventListener( 'keydown', function( event ) {
			if ( event.key === 'Escape' ) {
				const openSubMenus = document.querySelectorAll( 'li.has-submenu.submenu-open' );
				openSubMenus.forEach( function( menuItem ) {
					const toggle = menuItem.querySelector( '.submenu-toggle' );
					if ( toggle ) {
						toggle.setAttribute( 'aria-expanded', 'false' );
						menuItem.classList.remove( 'submenu-open' );
						// Return focus to the toggle button
						toggle.focus();
					}
				} );
			}
		} );
	}

	// Initialize when DOM is ready
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initSubMenus );
	} else {
		// DOM is already ready
		initSubMenus();
	}
}() );
